export function useShadowPulseAnimation(isActive = true, color = "primary") {
  let colorStart = "";
  let colorEnd = "";
  const keyframeName = `shadow-pulse-${color}`;

  switch (color) {
    case "primary":
      colorStart = "rgba(7, 141, 238, 0.7)";
      colorEnd = "rgba(7, 141, 238, 0)";
      break;
    case "success":
      colorStart = "rgba(34, 197, 94, 0.7)";
      colorEnd = "rgba(34, 197, 94, 0)";
      break;
    case "warning":
      colorStart = "rgba(255, 171, 0, 0.7)";
      colorEnd = "rgba(255, 171, 0, 0)";
      break;
    case "error":
      colorStart = "rgba(255, 86, 48, 0.7)";
      colorEnd = "rgba(255, 86, 48, 0)";
      break;
    default:
      break;
  }

  return {
    animation: isActive !== false ? `${keyframeName} 1.5s infinite` : "none",
    [`@keyframes ${keyframeName}`]: {
      "0%": {
        boxShadow: `0 0 0 0 ${colorStart}`,
      },
      "70%": {
        boxShadow: `0 0 0 10px ${colorEnd}`,
      },
      "100%": {
        boxShadow: `0 0 0 0 ${colorEnd}`,
      },
    },
  };
}
